import { Component, Input, OnInit, inject } from '@angular/core';
import { InsurancesDataInterface } from '@app/core/interfaces/insurances-data.interface';
import { ProductIdNameService } from '@app/core/services/product-id-name.service';
import { ProductIdEnum } from 'outshared-lib';
import { NativeRouterService } from '@inshared/shared/util';

@Component({
    selector: 'ins-insurance-images',
    templateUrl: './insurance-images.component.html',
    styleUrls: ['./insurance-images.component.scss'],
})

export class InsuranceImagesComponent implements OnInit {
    @Input() insurances: ProductIdEnum[];

    public nativeRouterService = inject(NativeRouterService);
    public insuranceData: InsurancesDataInterface[] = [];
    public baseUrl = this.nativeRouterService.baseUrl;

    ngOnInit(): void {
        this.transformInsurances();
    }

    public transformInsurances(): void {
        if (this.insurances) {
            for (const insurance of this.insurances) {
                switch (insurance) {
                    case ProductIdEnum.Car:
                        this.insuranceData.push({
                            title: 'Auto',
                            url: 'autoverzekering',
                            svgLink: 'auto',
                            routerLink: false,
                        });
                        break;
                    case ProductIdEnum.Moped:
                        this.insuranceData.push({
                            title: 'Brommer',
                            url: 'brommerverzekering',
                            svgLink: 'bromfiets',
                            routerLink: false,
                        });
                        break;
                    case ProductIdEnum.Pet:
                        this.insuranceData.push({
                            title: 'Dier',
                            url: 'dierenverzekering',
                            svgLink: 'huisdier',
                            routerLink: false,
                        });
                        break;
                    case ProductIdEnum.Liability:
                        this.insuranceData.push({
                            title: 'Aansprakelijkheid',
                            url: 'aansprakelijkheidsverzekering',
                            svgLink: 'aansprakelijkheid',
                            routerLink: false,
                        });
                        break;
                    case ProductIdEnum.Legal:
                        this.insuranceData.push({
                            title: 'Rechtsbijstand',
                            url: 'rechtsbijstandverzekering',
                            svgLink: 'rechtsbijstand',
                            routerLink: true,
                        });
                        break;
                    case ProductIdEnum.Furniture:
                        this.insuranceData.push({
                            title: 'Inboedel',
                            url: 'inboedelverzekering',
                            svgLink: 'inboedel',
                            routerLink: false,
                        });
                        break;
                    case ProductIdEnum.Building:
                        this.insuranceData.push({
                            title: 'Opstal',
                            url: 'opstalverzekering',
                            svgLink: 'opstal',
                            routerLink: false,
                        });
                        break;
                    case ProductIdEnum.Home:
                        this.insuranceData.push({
                            title: 'Woon',
                            url: 'woonverzekering',
                            svgLink: 'woonhuis',
                            routerLink: false,
                        });
                        break;
                    case ProductIdEnum.Bicycle:
                        this.insuranceData.push({
                            title: 'Fiets',
                            url: 'fietsverzekering',
                            svgLink: 'fiets',
                            routerLink: false,
                        });
                        break;
                    default:
                        const productName = ProductIdNameService.getProductNameByProductId(insurance);
                        const productShortName = productName.replace('verzekering', '');
                        this.insuranceData.push({
                            title: ProductIdNameService.capitalizeFirstLetter(productShortName),
                            url: productName,
                            svgLink: productShortName,
                            routerLink: false,
                        });
                        break;
                }
            }
        }
    }
}
